<template>
  <div
    class="project"
    :data-index="index"
    :class="{ active: project.isActive }"
    v-on:mouseover="project.isActive = true"
    v-on:mouseleave="project.isActive = false"
  >
    <a
      class="project__image"
      :href="getOverviewUrl()"
      :target="project.external_url ? '_blank' : '_self'"
    >
      <img class="image" v-lazy="project.image" />
      <img
        v-if="project.comingSoon"
        class="coming-soon"
        v-lazy="project.comingSoon"
      />
      <img v-else-if="project.logo" class="logo" v-lazy="project.logo" />
      <div
        v-else-if="project.thumbnailText"
        class="project__features"
        v-html="project.thumbnailText"
      ></div>
    </a>

    <h2 class="project__title">
      <a
        :href="
          project.external_url
            ? project.external_url
            : project.url + '#overview'
        "
        :target="project.external_url ? '_blank' : '_self'"
      >
        {{ project.title }}
      </a>
      <span v-if="project.rented === '1'">{{ rentedText }}</span>
    </h2>

    <div class="project__region">
      <span>{{ project.region }}</span>
      <span>{{ project.house }} {{ project.street }}</span>
    </div>

    <div class="project__infos">
      <div
        v-if="project.teaserText"
        class="project__from"
        v-html="project.teaserText"
      ></div>
      <div
        v-else-if="project.fromPrice && !project.hidePrice"
        class="project__from"
      >
        {{ fromText }} {{ project.fromPrice }}
        <sup v-if="project.isTax === '1'">+ {{ taxeText }}</sup>
      </div>
      <div
        v-else-if="project.showOfficePhone && project.officePhone"
        class="project__from"
      >
        <a :href="'tel:' + project.officePhone">{{ project.officePhone }}</a>
      </div>

      <a
        class="project__pdf"
        target="_blank"
        :href="project.projectBrochure"
        v-if="project.projectBrochure"
      >
        <span class="icon-download"></span> <span>{{ seeBrochureText }}</span>
      </a>
    </div>

    <div class="project__links">
      <a
        v-if="
          !(project.comingSoon || project.fullyRented) &&
          project.units &&
          project.units.length > 0
        "
        :href="
          project.external_url
            ? project.external_url
            : project.url + '?' + parameters + '#projectUnits'
        "
        :target="project.external_url ? '_blank' : '_self'"
      >
        <span
          >{{ seeUnitsText }}
          <!-- MON-204 -->
          <!-- <sup v-if="p.filteredUnits.length > 0 || projectTypePath !== '10'">{{ p.filteredUnits.length }}</sup> -->
        </span>
      </a>

      <a :href="getOverviewUrl()">
        <span v-if="project.comingSoon">{{ registerNowText }}</span>
        <span v-else-if="project.fullyRented">{{ waitingListText }}</span>
        <span v-else>{{ detailsText }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "project",
    "index",
    "parameters",
    "contactLinkRoot",
    "projectTypePath",
    "projectTypeTitle",
    "rentedText",
    "fromText",
    "taxeText",
    "seeBrochureText",
    "seeUnitsText",
    "registerNowText",
    "waitingListText",
    "detailsText",
  ],
  methods: {
    getOverviewUrl() {
      let url = this.project.url + "#overview";

      if (this.project.external_url) {
        url = this.project.external_url;
      } else if (this.project.fullyRented || this.project.comingSoon) {
        url =
          this.contactLinkRoot +
          "?projectId=" +
          this.project.id +
          "&" +
          "projectTypeId=" +
          this.projectTypePath +
          "&" +
          this.projectTypeTitle;
        if (this.project.fullyRented) {
          url += "&" + "waiting-list=true";
        } else {
          url += "&" + "coming-soon=true";
        }
      }

      return url;
    },
  },
};
</script>
